/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory, Link, withRouter } from "react-router-dom";


//i18n
import { withNamespaces } from "react-i18next";
import SidebarContent from "./SidebarContent";

// logo
import logo from "../../assets/images/logo.svg";
import check from "../../assets/images/check.svg";
import adminIcon from "../../assets/images/icon/admin-icon.svg";
import semuIcon from "../../assets/images/icon/semu-icon.svg";
import nomuIcon from "../../assets/images/icon/nomu-icon.svg";

// redux
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setProfile } from "../../store/actions";

// utils
import { viewLoading } from "../../utils/loading";

// api
import { getCompanyToken } from "../../apis/companies/companies";

//component
import Icon from "../Icon";
import systemAlert from "../../utils/systemAlert";
import { get } from "lodash-es";
import { classnames } from "../../utils/text";
import { getCompanyTokenInfo } from "../../apis/auth";
import { isManagingType } from "../../utils/auth";
import { getCareCompanies } from "../../apis/admin/companies";
import { isEmpty, uniqBy, orderBy } from "lodash";
import Input from "../Input";

const Sidebar = (props) => {

  const dispatch = useDispatch();
  const history = useHistory();
  const companyTokenInfo = getCompanyTokenInfo();

  const { companies, careCompanies } = useSelector((store) => store.Data);
  const { company, employee, isManaging } = useSelector((store) => store.Profile);
  // user, emplyee, 

  const [activeCompanyListTab, setActiveCompanyListTab] = useState(null);
  const [_careCompanies, _setCareCompanies] = useState([]);
  const [selectedManagingCompany, setSelectedManagingCompany] = useState(null);

  const [companyListTabList] = useState([
    {
      label: '소속회사',
      value: 'companies'
    },
    {
      label: '담당회사',
      value: 'careCompanies'
    }
  ]);

  const [searchText, setSearchText] = useState("");
  const _setSearchText = (e) => {
    setSearchText(e.target.value);
  };

  useEffect(() => {
    // 나의 타입이 매니저 일떄
    if (isManagingType()) {
      setActiveCompanyListTab(companyListTabList[1].value);
      //_setCareCompanies(careCompanies)
      _setCareCompanies([careCompanies[0], ...orderBy(careCompanies.slice(1), ["state", "managerLevel", "name"], ["asc", "asc", "asc"])]);
      setSelectedManagingCompany(careCompanies[0]);
    } else {
      setActiveCompanyListTab(companyListTabList[0].value);
    }
  }, [careCompanies]);

  // 회사 선택할때 다음 선택 회사 세팅
  const _setActiveCompanyListTab = (value) => {
    if (value === 'companies') {
      setSelectedManagingCompany(null);
      _setCareCompanies([]);
    }
    setActiveCompanyListTab(value);
  };

  const changeCompany = async (selectedCompany) => {
    if (activeCompanyListTab === 'companies' && selectedCompany.type !== 1) {
      setSelectedManagingCompany(selectedCompany);
      const careCompanies = await getCareCompanies(selectedCompany.companyIdx, selectedCompany.type);
      const _careList = orderBy(careCompanies.data.companies, ["state", "managerLevel", "name"], ["asc", "asc", "asc"]);
      _setCareCompanies([selectedCompany, ..._careList]);

      setActiveCompanyListTab('careCompanies');
      return false;
    }
    // 접속중인 회사
    if (companyTokenInfo.companyIdx === selectedCompany.companyIdx) return;

    if (selectedCompany.state === 'pause') {
      return systemAlert('일시 중지인 회사에는 접근할수 없습니다.');
    }
    if (selectedCompany.state === 'joined' || activeCompanyListTab === 'careCompanies') {
      systemAlert(`"${selectedCompany.name}"회사로 접속하시겠습니까?`, {
        buttons: [{
          label: '확인',
          onClick: () => {
            const companyIdx = selectedCompany.companyIdx;
            const type = activeCompanyListTab === 'careCompanies' ? selectedManagingCompany.type : selectedCompany.type;

            viewLoading(true);
            getCompanyToken({ companyIdx, type })
              .then(() => {
                dispatch(setProfile());
                history.push("/dashboard");
              })
              .catch((err) => {
                systemAlert(get(err, 'response.data.message') || err.response);
              })
              .finally(() => {
                viewLoading(false);
              });
          }
        }, {
          color: 'line',
          label: '취소',
        }]
      });
      return;
    } else {
      systemAlert(<>"{selectedCompany.name}"회사는 직원등록 대기중인 회사입니다. <br />다른회사를 이용해주세요.</>);
    }

  };
  return (
    <React.Fragment>
      <div className="vertical-menu print-out">

        <div data-simplebar className="h-100 print-out">
          <div className="navbar-brand-box">
            <div className="navbar-brand-inner">
              <Link to="/" className="logo">
                {employee && isManaging && employee.type === 2 && <span className="logo-Badg"><Icon src={semuIcon} /></span>}
                {employee && isManaging && employee.type === 3 && <span className="logo-Badg"><Icon src={nomuIcon} /></span>}
                {employee && isManaging && employee.type === 9 && <span className="logo-Badg"><Icon src={adminIcon} /></span>}
                <span className="logo-sm">
                  <Icon src={logo} alt="" height="36" />
                </span>
                <span className="logo-lg">
                  <Icon src={logo} alt="" height="36" />
                </span>
              </Link>
              {/* {!isTestCompany() && <> */}
              {
                company && <div className="current-company">
                  {
                    !company.taxCompany && company.taxCompanyCodeCompany && <div className="tax-company">
                      요청대기중{company.taxCompanyCodeCompany.name}
                    </div>
                  }
                  {company.name}
                  {
                    company.code && <p style={{
                      marginTop: '-10px',
                      lineHeight: 1,
                      textAlign: 'center',
                      fontSize: '12px',
                      color: '#888888'
                    }}>
                      <br />({company.code})
                    </p>
                  }
                </div>
              }
              {/* </>} */}
              <div className="company-list-wrap">
                <div className="company-list-tab">
                  {companyListTabList && companyListTabList.map((tab, idx) => <a
                    key={idx}
                    className={classnames({
                      'active': activeCompanyListTab === tab.value,
                      'hide': !selectedManagingCompany && tab.value === 'careCompanies'
                    })}
                    onClick={() => _setActiveCompanyListTab(tab.value)}
                  >
                    {tab.label}
                  </a>)}
                  {activeCompanyListTab === 'careCompanies' &&
                    <Input
                      name={"search-text"}
                      placeholder={"회사명 검색"}
                      value={searchText}
                      onChange={_setSearchText}
                      className={"search-text-input"}
                      style={{
                        'marginTop': '10px',
                        'border': '1px solid #ddd',
                        'padding': '0 5px'
                      }}
                    />
                  }
                </div>
                {
                  activeCompanyListTab === 'companies' && <ul className="company-list">
                    {company && uniqBy(companies, 'companyIdx').map((_company, idx) => <li key={idx}>
                      <a
                        className={classnames({ active: _company.companyIdx === company.idx })}
                        onClick={() => changeCompany(_company)}
                      >
                        {_company.name}<Icon src={check} />
                      </a>
                    </li>)}
                  </ul>
                }
                {
                  activeCompanyListTab === 'careCompanies' && <ul className="company-list">
                    {
                      // 담당회사 부분
                      company && !isEmpty(_careCompanies) ? (_careCompanies || []).filter((c) =>
                        c?.name?.includes(searchText)
                      ).map((_company, idx) =>
                        !!_company && _company.state !== 'pause' &&
                        <React.Fragment key={idx}>
                          <li>
                            <a
                              className={classnames({ active: _company.companyIdx === company.idx })}
                              onClick={() => changeCompany(_company)}
                            >
                              {_company.name}<Icon src={check} />
                            </a>
                          </li>
                        </React.Fragment>
                      )
                        :
                        <li>
                          <a>
                            담당회사가 없습니다.
                          </a>
                        </li>
                    }
                  </ul>
                }

              </div>
            </div>
          </div>
          <div className={classnames("lnb-wrap", {
            "has-manager": company && company.taxCompany
          })}>
            {props.type !== "condensed" ? (
              <SidebarContent />
            ) : (
              <SidebarContent />
            )}
          </div>

          {
            company && company.taxCompany &&
            <div className="manager-info-wrap">
              <div className="tax-company">
                {/* <span className="logo-Badg"><Icon src={semuIcon} /></span> */}
                {/* {employee && isManaging && employee.type === 3 && <span className="logo-Badg"><Icon src={nomuIcon} /></span>} */}
                {company.taxCompany.name}
              </div>
            </div>
          }
        </div>

      </div>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withNamespaces()(Sidebar)));
